/*
=========================================================
* Material Kit 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, useRef, useReducer, act } from "react";
import { useParams } from 'react-router-dom';
// @mui material components
import Breadcrumbs from "components/Breadcrumbs";
 
import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar';
import Slide from '@mui/material/Slide';
 
// Material Kit 2 PRO React components

import MKBox from "components/MKBox";  
import Card from "@mui/material/Card";
import { useNavigate } from "react-router-dom"
import AppLayout from "components/Layouts/AppLayout"; 
 
import { appAuth } from "../contexts/AppContext" 
import AppMenu from "components/AppKey/AppMenu"; 
import EmailTemplate from "components/AppKey/EmailTemplate"; 
import AppLogs from "components/AppKey/AppLogs";
import AppSetting from "components/AppKey/AppSetting";
import AppOption from "components/AppKey/AppOption";
import AppUser from "components/AppKey/AppUser";
import AppKey from "components/AppKey/AppKey"; 
import AppAction from "components/AppKey/AppAction"; 

export default function AppDetail() {  
 
    const [successMessage, setSuccessMessage] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const [appState, setAppState] = useState({activeTab:-1}) 
    const [appMenuItems, setAppMenuItems] = useState([{icon:"settings", label:"Settings", active:true, index:0}, {icon:"tune", label:"Options", active:false, index:1}, {icon:"manage_accounts", label:"Users", active:false, index:2}, {icon:"key", label:"Keys", active:false, index:3}, {icon:"forward_to_inbox", label:"Templates", active:false, index:4}, {icon:"query_stats", label:"Logs", active:false, index:5}, {icon:"qr_code", label:"Action", active:false, index:6}])

    const [modalState, setModalData] = useState({showSuccess:false})
    const navigate = useNavigate() 
    const {isLoggedIn, currentApp,  getApp, requestError, requestSuccess, setRequestError, setRequestSuccess} = appAuth() 
  
    const [appToEdit, setAppToEdit] = useState(currentApp) 
    let { appId } = useParams(); 

    const handleChangeAppMenu = (item, prevItem) => {
        let isUpdatingUser =  localStorage.getItem('isUpdatingUser');  
        if(isUpdatingUser && isUpdatingUser == "true"){
            if(window.confirm("You have unsaved changes. Are you sure to leave?")) {
                setAppState({...appState, ["activeTab"]: item.index})
                localStorage.setItem('isUpdatingUser', "false");  
            }
            else {

                setAppState({...appState, ["activeTab"]: prevItem.index})

                setAppMenuItems(appMenuItems.map(menuItem => {
                    if (menuItem.index === prevItem.index) return {...menuItem, active:true}
                    else return {...menuItem, active:false}
                })) 
                 
            }
        }
        else setAppState({...appState, ["activeTab"]: item.index})

        console.log("handleChangeAppMenu ", item) 
       
       
    };  
    const renderRef = useRef(false) 


    useEffect(() => { 

        if(requestError) showError(requestError.message)
        else if(requestSuccess) showSuccess(requestSuccess.message)
        
        console.log("AppDetail useEffect requestError ", requestError)

    }, [requestError, requestSuccess])

    useEffect(() => {  
        if(currentApp) setAppToEdit(currentApp) 
    }, [currentApp])

    function showError(message){
        setErrorMessage(message);

        setModalData({...modalState, ["showError"]: true});


        setTimeout(() => {
            setErrorMessage(); 
        }, 5000);
        
        setRequestError(null)
    }

    
    
    const handleCloseSnackbar = (type) => { 
        setModalData({...modalState, [type]: false});
    };

      
    function showSuccess(message){

        setSuccessMessage(message);
        setModalData({...modalState, ["showSuccess"]: true});

        setTimeout(() => { 
            setSuccessMessage();
        }, 5000);
        
        setRequestSuccess(null)
    }

    function SlideTransition(props) {
        return <Slide {...props} direction="up" />;
    }

    
    useEffect(() => { 
        console.log(" AppDetail start render . ")

        const loggedInUser = isLoggedIn();
        if (!loggedInUser) navigate("/signin")

        if (renderRef.current === false){

            async function fetchApp() {
                
                let app = await getApp(appId);
               

                if(app === undefined){
                    navigate("/apps")
                    return
                } 

                setAppToEdit(app);
                    
                console.log("AppDetail appToEdit ", appToEdit)  
                setAppState({...appState, ["activeTab"]: 0})
            }

            fetchApp()

            return () => {
                renderRef.current = true
                console.log("AppDetail render clean up. ")
            }
        }

       

    }, []) 
 
 

    return (
    <> {currentApp !== undefined  &&  currentApp !== null && currentApp.name && 
    <AppLayout>
       
       <MKBox component="section" > 
            <Breadcrumbs pb={2} 
                routes={[
                    { label: "Apps", route: "/apps" },
                    { label: currentApp.name},
                        
                ]}
            />   

            <AppMenu clickItemHandler={handleChangeAppMenu} items={appMenuItems}/>
  
            <Card sx={{ p: 1,   mb: 4, boxShadow: ({ boxShadows: { xxl } }) => xxl,}} >
                
            <MKBox component="section" >   
                
                { appState.activeTab === 0  && <MKBox
                                        role="tabpanel" 
                                        id={`app-tabpanel-${appState.activeTab}`}
                                        aria-labelledby={`app-tab-${appState.activeTab}`}> 
                    <AppSetting app={appToEdit}/> 

                </MKBox> }
                
                { appState.activeTab === 1 && <MKBox
                                        role="tabpanel" 
                                        id={`app-tabpanel-${appState.activeTab}`}
                                        aria-labelledby={`app-tab-${appState.activeTab}`} > 
                   
                    <AppOption app={appToEdit} />

                     
                </MKBox>}

                { appState.activeTab === 2 && <MKBox
                                        role="tabpanel" 
                                        id={`app-tabpanel-${appState.activeTab}`}
                                        aria-labelledby={`app-tab-${appState.activeTab}`} > 

                    <AppUser app={appToEdit} />
                
                </MKBox> }
                
                { appState.activeTab === 3 && <MKBox
                                        role="tabpanel" 
                                        id={`app-tabpanel-${appState.activeTab}`}
                                        aria-labelledby={`app-tab-${appState.activeTab}`} > 
                    
                    <AppKey app={appToEdit} />
                         

                </MKBox> }

                { appState.activeTab === 4  && <MKBox
                                        role="tabpanel" 
                                        id={`app-tabpanel-${appState.activeTab}`}
                                        aria-labelledby={`app-tab-${appState.activeTab}`} > 
                    
                    <EmailTemplate app = {appToEdit}  /> 
                </MKBox> }

                { appState.activeTab === 5 && <MKBox
                                        role="tabpanel" 
                                        id={`app-tabpanel-${appState.activeTab}`}
                                        aria-labelledby={`app-tab-${appState.activeTab}`} > 
                    <AppLogs app={appToEdit}/>
                </MKBox>
                }

                { appState.activeTab === 6 && <MKBox
                                        role="tabpanel" 
                                        id={`app-tabpanel-${appState.activeTab}`}
                                        aria-labelledby={`app-tab-${appState.activeTab}`} > 
                    <AppAction app={appToEdit}/>
                </MKBox>
                }

                
            </MKBox>
        </Card>
        </MKBox> 

        <Snackbar
            ContentProps={{
                sx: {
                  background: "#4638ab"
                }
            }}
            autoHideDuration={5000} onClose={ () => handleCloseSnackbar("showSuccess")}
            anchorOrigin={{ vertical:"top", horizontal:"right" }} 
            open={modalState.showSuccess } 
            message= {successMessage}
            slots={{ transition: SlideTransition }}
            
        />

        <Snackbar
            ContentProps={{
                sx: {
                  background: "#ea4844"
                }
            }}
            autoHideDuration={5000} onClose={() => handleCloseSnackbar("showError")}
            anchorOrigin={{ vertical:"top", horizontal:"right" }} 
            open={modalState.showError } 
            message= {errorMessage}
            slots={{ transition: SlideTransition }}
            
        />

        
        
    </AppLayout>
    }
    </>

    );

 
  


}
